// @ts-nocheck
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getOrgType } from '../../store/Lookup/lookupSlice';
import { useTranslation } from 'react-i18next';

const useLookupOrgType = () => {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();

  useEffect(() => {
    dispatch(getOrgType());
  }, [dispatch]);

  const { ORG_TYPE, loading, error } = useSelector((state) => state.Lookup);

  const OrgTypeList =
    ORG_TYPE &&
    ORG_TYPE?.map((item, idx) =>
      item.list?.map((list) => ({
        value: list.lookupCode,
        label: i18n.language === 'en' ? list.meaning : list.meaning2,
      }))
    ).flat();
  return { ORG_TYPE, OrgTypeList, loading, error };
};

export default useLookupOrgType;
